import { useParams } from "react-router-dom";
import "../../i18n/i18n";
import { VehiclesTable } from "./vehiclesTable";
import { useVehicles } from "./useVehicles";

export const VehiclesOfACompanyTab = () => {
  const params = useParams();
  const vehiclesListWithId = useVehicles();

  if (params.tab !== "vehiclesOfACompany") {
    return;
  }

  return (
    <VehiclesTable
      vehiclesListWithId={vehiclesListWithId}
      pageName="vehiclesOfACompany"
      pageTitle="Vehicles-of-a-Company"
    />
  );
};
